import { mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { IClientApiDependencySegment, catchApiError } from '@cbridge-packages/api';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { PricingProfileAction } from '../pricingProfile.action';
import { PricingProfileTranslator } from '../pricingProfile.translator';

type IDependencies = IClientApiDependencySegment;

export const loadPricingProfileListEpic: IEpic<{}, IDependencies> = (action$, _, dependencies) => action$.pipe(
  isTypeOfAndGetPayload(PricingProfileAction.loadList.started),
  mergeMap(() => {
    return dependencies.api.getPricingProfileList().pipe(
      mergeMap((response) => {
        const profiles = (response.pricingProfiles ?? []).map(PricingProfileTranslator.fromApi);

        return [
          PricingProfileAction.loadList.done({ result: profiles }),
        ];
      }),
      catchApiError((error) => {
        return [
          PricingProfileAction.loadList.failed({ error }),
          createApiErrorNotification(error),
        ];
      }),
    );
  }),
);
